import i18n from 'common/i18n';

document.addEventListener('DOMContentLoaded', () => {
  const link = document.getElementById('discount-code-link');
  const field = document.getElementById('discount-code-field');
  const submit = document.getElementById('discount-code-submit');
  const input = document.getElementById('discount-code-input');
  const errorMessage = document.getElementById('dicount-code-error-message');

  if (link && field && input && submit) {
    link.addEventListener('click', () => {
      field.classList.toggle('d-none');
    });

    submit.addEventListener('click', () => {
      if (input.value.length > 0) {
        submit.disabled = true;
        submit.innerHTML = '<i class=\'spinner-border spinner-border-sm\'></i>';

        Rails.ajax({
          url: `/${input.dataset.slug}/products/discount_code`,
          type: 'POST',
          data: `discount_code=${input.value.trim()}&order_id=${input.dataset.orderId}`,
          success: () => {
            const showPlan = document.getElementById('pay_in_installments');
            const basePlanId = document.getElementById('base_plan_id');

            if (showPlan?.checked) {
              window.location.search = `?show_plan=1&plan_id=${basePlanId?.value}`;
            } else {
              window.location.reload();
            }
          },
          error: (response, _, xhr) => {
            if (xhr.status === 422) {
              errorMessage.classList.add('d-none');
              window.location.reload();
            } else {
              submit.disabled = false;
              submit.innerHTML = i18n.t('payment_form.discount_code.check');
              errorMessage.classList.remove('d-none');
              errorMessage.querySelector('div').innerHTML = response.message;
            }
          }
        });
      }
    });
  }
});
